import "../../node_modules/virtual-select-plugin/dist/virtual-select.min.js";

let slidersBreakpoint = 1;

let sizeChangeSliders = window.matchMedia("(max-width:"+slidersBreakpoint+"px)")
sizeChangeSliders.addListener(SelectResizeChecker)

function SelectResizeChecker(){
    destroy_select_categories();
}

const selects = document.getElementsByClassName('map-category-select');
function build_select_categories(el)
{
    VirtualSelect.init({ 
        ele: el,
        search: false,
        dropboxWrapper: '.map-filters__filters',
        disableSelectAll:true,
        optionsSelectedText:el.getAttribute('placeholder'),
        optionSelectedText:el.getAttribute('placeholder'),
        disableAllOptionsSelectedText:true,
        alwaysShowSelectedOptionsCount:true,
        hideClearButton: true,
        popupDropboxBreakpoint: "1px",
    });
    localStorage.setItem('renderSize',window.screen.width);
}
function destroy_select_categories(){
    /*if(selects){
        Array.prototype.forEach.call(selects,function(el){
            el.destroy();
            build_select_categories(el);
        });
    }*/
}


if(selects){
    Array.prototype.forEach.call(selects,function(el){
        build_select_categories(el);
    });
}

document.addEventListener('keydown', function(e){
    //console.log(e.key);
    Array.prototype.forEach.call(selects,function(el){
        if(e.key == 'Tab'){
            el.close();
        }
    })
})